'use client';

import { create } from 'zustand';

interface AchievementSheetState {
  openKey: string | null;
  open: (key: string) => void;
  close: () => void;
}

export const useAchievementSheetStore = create<AchievementSheetState>((set) => ({
  openKey: null,
  open: (openKey) => set({ openKey }),
  close: () => set({ openKey: null }),
}));

export const useAchievementSheetKey = () => useAchievementSheetStore((s) => s.openKey);
export const useOpenAchievementSheet = () => useAchievementSheetStore((s) => s.open);
export const useCloseAchievementSheet = () => useAchievementSheetStore((s) => s.close);
